import gql from 'graphql-tag';

export default gql`
    mutation createAssets($input: [NewAssetInput]!) {
      createAssets( input: $input) {
            assetId
            organisationId
            filename
            title
            description
            tags
            altText
            updatedAt
            metaData
            createdByUser {
              firstName,
              lastName
            },
            updatedByUser {
              firstName,
              lastName
            },
            assetFiles {
              ORIGINAL {
                assetFileId
                status
                sourceUrl
              }
            }
        }
    }
`;